module.exports = __webpack_public_path__ + "static/media/1.e15d03d9.jpg";